import { render, staticRenderFns } from "./TeamgroupIndex.vue?vue&type=template&id=11612fde&scoped=true&"
import script from "./TeamgroupIndex.vue?vue&type=script&lang=js&"
export * from "./TeamgroupIndex.vue?vue&type=script&lang=js&"
import style0 from "./TeamgroupIndex.vue?vue&type=style&index=0&id=11612fde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11612fde",
  null
  
)

export default component.exports